<template>
  <div class="container">
    <h1 class="py-4">HOME</h1>
    <div class="row">
      <div class="col-sm-12 mb-4">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">仕事管理</h2>
            <p class="card-text">仕事の一覧と登録・編集等の管理</p>
            <router-link :to="{ name: 'Jobs' }" class="btn btn-primary mr-2 mb-2">仕事一覧</router-link>
            <router-link :to="{ name: 'RegisterJob' }" class="btn btn-primary mr-2 mb-2">仕事登録</router-link>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-4">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">ダウンロード</h2>
            <p class="card-text">各種データの出力・ダウンロード
            </p>
            <router-link :to="{ name: 'OutputData', query: { target: 'user' } }" class="btn btn-primary mr-2 mb-2">顧客情報</router-link>
            <router-link :to="{ name: 'OutputData', query: { target: 'jobs' } }" class="btn btn-primary mr-2 mb-2">仕事情報</router-link>
            <router-link :to="{ name: 'OutputData', query: { target: 'job_apply' } }" class="btn btn-primary mr-2 mb-2">仕事応募履歴</router-link>
            <router-link :to="{ name: 'OutputData', query: { target: 'job_detail_view_histories' } }" class="btn btn-primary mr-2 mb-2">仕事閲覧履歴</router-link>
            <router-link :to="{ name: 'OutputData', query: { target: 'service_link_click_histories' } }" class="btn btn-primary mr-2 mb-2">サービスリンク履歴</router-link>
          </div>
        </div>
      </div>
       <div class="col-sm-12 mb-4">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">新機能</h2>
            <p class="card-text">2020/10以降の新規機能分のデータ出力・ダウンロード
            </p>
            <h4>c.choysan</h4>
            <router-link :to="{ name: 'OutputData',query:{target:'userList'}}" class="btn btn-primary mr-2 mb-2">顧客情報</router-link>
            <router-link :to="{ name: 'OutputData',query:{target:'userLog'}}" class="btn btn-primary mr-2 mb-2">ログ情報</router-link>
            <router-link :to="{ name: 'Partners'}" class="btn btn-primary mr-2 mb-2">パートナー管理</router-link>
            <h4>BANKITアプリ</h4>
            <p class="bulletPoint">データ管理</p>
            <router-link :to="{ name: 'MasterData'}" class="btn btn-primary mr-2 mb-2">マスターデータ</router-link>
            <router-link :to="{ name: 'ApplicationUserData'}" class="btn btn-primary mr-2 mb-2">アプリユーザデータ</router-link>
            <router-link :to="{ name: 'PaymentMethod'}" class="btn btn-primary mr-2 mb-2">決済手段</router-link>
            <router-link :to="{ name: 'Transactions'}" class="btn btn-primary mr-2 mb-2">トランザクション</router-link>
            <router-link :to="{ name: 'PaymentTransactions'}" class="btn btn-primary mr-2 mb-2">取引詳細（決済サービス）</router-link>
            <router-link :to="{ name: 'Merchant'}" class="btn btn-primary mr-2 mb-2">加盟店マスタ</router-link>
            <router-link :to="{ name: 'MerchantTerminal'}" class="btn btn-primary mr-2 mb-2">加盟店端末情報</router-link>
            <router-link :to="{ name: 'OtasukeForecast'}" class="btn btn-primary mr-2 mb-2">おたすけ返済予実情報</router-link>
            <router-link :to="{ name: 'OtasukeRepayment'}" class="btn btn-primary mr-2 mb-2">おたすけ返済実施詳細</router-link>
            <p class="bulletPoint">抽出機能</p>
            <router-link :disabled="true" tag="button" :to="{ name: 'Points'}" class="btn btn-primary mr-2 mb-2">ポイント付与管理</router-link>
            <router-link :disabled="true" tag="button" :to="{ name: 'Notifications'}" class="btn btn-primary mr-2 mb-2">Push通知管理</router-link>
            <p class="bulletPoint">サマリ</p>
            <router-link :to="{ name: 'UserRegistrationSummary'}" class="btn btn-primary mr-2 mb-2">BANKIT-ChoySanユーザ登録サマリ</router-link>
            <router-link :to="{ name: 'TransactionRecordSummary'}" class="btn btn-primary mr-2 mb-2">取引実績サマリ</router-link>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
